export function buildIncludeTestOrdersQueryParam(
  includeTestOrders = false,
): string {
  return includeTestOrders ? "&includeTestOrders=true" : "";
}

export function shouldIncludeTestOrdersFromFilter(filterObject: {
  includeTestOrders?: boolean;
  testOrderStatus?: string;
}): boolean {
  return (
    filterObject.includeTestOrders === true ||
    filterObject.testOrderStatus === "TEST"
  );
}